import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ContactDelivery = () => {
  const [showModal, setShowModal] = useState(false);
  const [userLocation, setUserLocation] = useState("");
  const [customMessage, setCustomMessage] = useState("");

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setUserLocation("");
    setCustomMessage("");
  };

  const handleSendWhatsApp = () => {
    const phone = "263777160749";
    const defaultMsg = "Hi! I live outside your delivery zone.";
    const locationPart = userLocation ? ` My location is: ${userLocation}.` : "";
    const userMsg = customMessage ? ` ${customMessage}` : "";
    const finalMessage = `${defaultMsg}${locationPart}${userMsg}`;

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(finalMessage)}`;
    window.open(url, "_blank");
    handleCloseModal();
  };

  const deliveryInfoStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.96)",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.12)",
    backdropFilter: "blur(20px)",
    border: "none",
    borderRadius: "16px",
    padding: "2rem",
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Contact & Delivery Info</h2>
      <div style={deliveryInfoStyle}>
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-2">🚚 Professional Delivery Service</h4>
          <p className="text-muted mb-0 small">Fast, reliable delivery across Harare and surrounding areas</p>
        </div>

        <div className="row g-4">
          {/* Standard Zone */}
          <div className="col-lg-6">
            <div className="p-3 border-start border-success border-3 bg-light bg-opacity-50 rounded-end">
              <h6 className="fw-bold text-success">📍 Standard Zone</h6>
              <p className="mb-2"><strong>$3.00</strong> delivery fee</p>
              <p className="text-muted mb-1 small">
                <strong>Coverage:</strong> 15km radius from Highlands Park
              </p>
              <small className="text-success">✓ Every Wednesday deliveries</small> <br />
              <small className="text-success">✓ The order deadline is Monday at 6 PM. Any orders placed after this time will be carried forward to the following week Wednesday deliveries.</small>
            </div>
          </div>

          {/* Extended Zone */}
          <div className="col-lg-6">
            <div className="p-3 border-start border-dark border-3 bg-light bg-opacity-50 rounded-end">
              <h6 className="fw-bold text-dark">🌍 Extended Zone</h6>
              <p className="text-muted mb-1 small">
                <strong>Coverage:</strong> Beyond 15km radius
              </p>
              <small className="text-success">✓ Orders outside the standard delivery zone may incur extra fees. Contact support via.</small>
              <div className="mt-2">
                <Button variant="outline-success" size="sm" onClick={handleOpenModal}>
                   WhatsApp
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-4 p-3 bg-primary bg-opacity-10 border-start border-dark border-3 rounded-end">
          <h6 className="fw-bold text-black mb-2">Delivery Policy</h6>
          <p className="mb-0 text-muted small">
            Orders outside the standard delivery zone may incur extra fees. Contact support via WhatsApp or Email for more details.
          </p>
        </div> */}
      </div>

      {/* WhatsApp Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Hi 👋</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>I live outside your delivery zone. I need to know how much to deliver in my area.</p>
          <Form.Group className="mb-3">
            <Form.Label>Enter your location</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. Borrowdale, Waterfalls"
              value={userLocation}
              onChange={(e) => setUserLocation(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Custom message (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="e.g. I would like delivery on Saturday."
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleSendWhatsApp}
            disabled={!userLocation.trim()}
          >
            Send on WhatsApp
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ContactDelivery;
